import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AdminUserService } from '../../services/admin-user.service';

import { EventService, Event, EventByYear } from '../../services/event.service';
import { LoadingService } from '../../services/loading.service';
import { CreateEventModalComponent } from './components/create-event-modal/create-event-modal.component';

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit, OnDestroy {

  selectedEvent: Event = null;
  activeEvent: Event = null;
  pastEventsGroups: EventByYear[];

  loading: boolean = false;
  isDNR: boolean = false;

  private unsubscribe: Subject<any> = new Subject();

  @ViewChild('createEventModal', { static: false }) createEventModal: CreateEventModalComponent;

  constructor(
    private loadingService: LoadingService,
    private userAdminService: AdminUserService,
    private eventService: EventService
  ) { }

  ngOnInit() {
    this.loadingService.currentLoading
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(loading => {
        this.loading = loading;
      });

    this.userAdminService.checkIsDNR();
    this.userAdminService.isDNR
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(dnrClaim => {
        if (!!dnrClaim) {
          this.isDNR = dnrClaim.claimValue === "yes";
        }
      });

    this.eventService.getActiveEvent();
    this.eventService.activeEvent
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(activeEvent => {
        this.activeEvent = activeEvent;
        if (!this.selectedEvent)
          this.selectedEvent = this.activeEvent;
      });

    this.eventService.getClosedEventsGrouped();
    this.eventService.closedEventsGroups
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(closedEventsGroups => {
        this.pastEventsGroups = closedEventsGroups;
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  showEvent(event: Event) {
    this.selectedEvent = event;
  }

  hideEvent() {
    this.selectedEvent = null;
  }

  createEvent() {
    this.createEventModal.open().then(() => 
      {
        console.info('Excess Flow Event Created!');
      }
    ).catch(
      (error) => console.warn(`Modal dismissed: ${error}`)
    )
  }

}

